import { Dialog, DialogPanel } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { IoMdClose } from "react-icons/io";
import { useState } from "react";
import Loading from "../Loading";
import { FiAlertTriangle } from "react-icons/fi";

export default function DeleteConfirmationModel({
    open,
    setOpen,
    onConfirm,
    title = 'confirm_delete',
    message = 'are_you_sure_delete',
    confirmText = 'delete',
    cancelText = 'cancel',
}) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm();
            setOpen(false);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        if (!loading) {
            setOpen(false);
        }
    };

    return (
        <Dialog
            open={open}
            as="div"
            className="relative z-40 focus:outline-none"
            onClose={handleClose}
        >
            <div className="fixed inset-0 bg-black/40" />
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4">
                    <DialogPanel
                        transition
                        className="w-full max-w-md rounded-2xl bg-white p-6 duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0"
                    >
                        <div className="flex items-start">
                            <div className="flex-shrink-0 mr-4">
                                <FiAlertTriangle className="h-10 w-10 text-red-500" aria-hidden="true" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-xl font-bold text-gray-900">{t(title)}</h3>
                                <p className="mt-2 text-sm text-gray-600">{t(message)}</p>
                            </div>
                            <IoMdClose
                                className="cursor-pointer text-gray-500 hover:text-gray-800"
                                fontSize={24}
                                onClick={handleClose}
                            />
                        </div>

                        <div className="mt-6 flex justify-end gap-4">
                            <button
                                type="button"
                                className="secondary-btn"
                                onClick={handleClose}
                            >
                                {t(cancelText)}
                            </button>
                            <button
                                type="button"
                                className="danger-btn"
                                onClick={handleConfirm}
                                disabled={loading}
                            >
                                {loading ? <Loading size={5} /> : t(confirmText)}
                            </button>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
} 